import { css } from 'styled-components';
import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

function ConditionsTextBlock({
  titleIntlKey,
  titleIntlValues,
  textIntlKey,
  textIntlValues,
  titleVariant,
  textVariant,
  titleStyling,
  textStyling,
}) {
  return (
    <>
      {titleIntlKey && (
        <Typography
          css={css`${titleStyling}`}
          color="black.default"
          variant={titleVariant}
          marginBottom="16px"
          intlKey={titleIntlKey}
          intlValues={titleIntlValues}
        />
      )}

      {textIntlKey && (
      <Typography
        css={css`${textStyling}`}
        color="black.default"
        variant={textVariant}
        intlKey={textIntlKey}
        intlValues={textIntlValues}
        marginBottom="16px"
      />
      )}
    </>
  );
}

ConditionsTextBlock.defaultProps = {
  textIntlValues: undefined,
  titleIntlKey: undefined,
  titleIntlValues: undefined,
  textIntlKey: undefined,
  titleVariant: 'heading4',
  textVariant: 'subtitle1',
  titleStyling: '',
  textStyling: 'strong { font-weight: bold;}',
};

ConditionsTextBlock.propTypes = {
  textIntlKey: PropTypes.string,
  textIntlValues: PropTypes.oneOfType([PropTypes.object]),
  textStyling: PropTypes.string,
  textVariant: PropTypes.string,
  titleIntlKey: PropTypes.string,
  titleIntlValues: PropTypes.oneOfType([PropTypes.object]),
  titleStyling: PropTypes.string,
  titleVariant: PropTypes.string,
};

export default ConditionsTextBlock;
